import { Action } from 'redux';
import { ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Dependencies } from '../../../../store';
import { PayloadAction } from '../../../../store.model';
import { BehaviourLibraryService, BlListDocumentParams } from '../../core';
import { ActionType } from '../bl-dialog.action';

import {
    ListDocuments,
    ListDocumentsResult,
    listDocumentsResult,
} from './list-documents.action';

export const listDocumentsEpic = (
    action: Observable<PayloadAction<ActionType, ListDocuments>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<Action | PayloadAction<ActionType, ListDocumentsResult>> =>
    action.pipe(
        ofType(ActionType.COACHING__BL__LIST_DOCUMENTS),
        switchMap((act: PayloadAction<ActionType, ListDocuments>) => {
            const service = deps.injector.get<BehaviourLibraryService>(
                BehaviourLibraryService,
            );

            const opts: BlListDocumentParams = {
                focuses: [act.payload.focus],
                languageId: null,
                includeEditorState: null,
                published: true,
            };

            return service.listDocuments(opts).pipe(
                map((ret) => {
                    return listDocumentsResult(
                        {
                            ...act.payload,
                            documents: ret,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    const result: Action = { type: '' };
                    return of(result);
                }),
            );
        }),
        catchError((err) => {
            console.log(err);
            const result: Action = { type: '' };
            return of(result);
        }),
    );
